import React from 'react'

import Icon from '@emcm-ui/component-icon';
import Typestack from '../../../typestack'
import { ExportWrapper, ExportOptions, IconHeader, ExportButton, ExportLink, Helper } from './Export.styles'

import {populateString} from '../../utils/strings'

import RadioControlBox from './RadioControlBox'


const ExportComponent = ({ formats, events, filters, filteredSize, description, i18n, contentFilterChecked, showDownloadConfirmationLimit, sortEngine, exportLimit }) => {
  const isFilteredSizeVisible = filters.length > 0 && !showDownloadConfirmationLimit && contentFilterChecked && sortEngine === 'client'

  const radioOptionsFormats = formats.map( format => ({ 
    value: format.name,
    label: format.name,
    onChange: events.handleFormatChange
  }))
  
  const radioOptionsContent = [
    { value: 'content_filter1', label: `Filtered table (${filters.length} filters applied)`, onChange: events.handleFormatChange },
    { value: 'content_filter2', label: 'Entire table', onChange: events.handleFormatChange }
  ]

  return (
    <ExportWrapper>
      <IconHeader>
        <Icon
          path="./icons/ui/grey/download-07.svg"
          size="s"
        />
      </IconHeader>
      {showDownloadConfirmationLimit &&
        <Typestack type='heading' size='md' weight='regular'>
          {i18n.downloadConfirm}
        </Typestack>
      }
      {!showDownloadConfirmationLimit &&
        <Typestack type='heading' size='md' weight='regular'>
          {i18n.download}
        </Typestack>
      }
      {filters.length > 0 && 
        <Typestack type='paragraph' size='lg' style={{visibility: isFilteredSizeVisible ? 'visible' : 'hidden'}}>
          {filteredSize.length} {description}
        </Typestack>
      }
      <ExportOptions>
        <Helper>{i18n.selectFileFormat}</Helper>
        
        {formats.length > 0 && !showDownloadConfirmationLimit &&
          <RadioControlBox options={radioOptionsFormats} name='radio-export-formats' />
        }
        
        {showDownloadConfirmationLimit &&
          <Typestack type='paragraph' size='md'>
            {populateString(i18n.downloadConfirmMessage, [exportLimit])}
          </Typestack>
        }
      </ExportOptions>

      {filters.length > 0 && !showDownloadConfirmationLimit &&

        <ExportOptions>
          <Helper>{i18n.selectRange}</Helper>
          <RadioControlBox options={radioOptionsContent} name='radio-export-content' />
        </ExportOptions>

      }

      <br />

      {showDownloadConfirmationLimit &&
        <ExportButton onClick={events.handleDownload}>{i18n.continue}</ExportButton>
      }
      {!showDownloadConfirmationLimit &&
        <ExportButton onClick={events.handleApplyDownload}>{i18n.apply}</ExportButton>
      }
      
      <ExportLink onClick={events.handleClose}>{i18n.cancel}</ExportLink>

    </ExportWrapper>
  )
}

export default ExportComponent
